<template>
    <div class="game-modal-content">
        <!-- 街舞数据 -->
        <template v-if="currentMatch.programId==47">
            <!-- 头部名称 -->
            <StreeModalName v-if="gameModalPeopleData.technicalHeaderVo" :technicalHeaderVo="gameModalPeopleData.technicalHeaderVo"   />
            <!-- 人物头像 -->
            <StreetModalAvatar v-if="gameModalPeopleData.technicalHeaderVo&&gameModalPeopleData.technicalHeaderVo.bluePlayers.length==1" :technicalHeaderVo="gameModalPeopleData.technicalHeaderVo" :combatName="this.currentMatch.combatName" />
            <StreetModalAvatarGroup v-if="gameModalPeopleData.technicalHeaderVo&&gameModalPeopleData.technicalHeaderVo.bluePlayers.length>1"  :technicalHeaderVo="gameModalPeopleData.technicalHeaderVo" :combatName="this.currentMatch.combatName"/>
            <!-- 分数 -->
            <template v-if="gameModalPeopleData.detail">
                <StreeModalContent v-if="gameModalPeopleData.detail&&!isDetail" :scoreDetail="gameModalPeopleData.detail" :allData="gameModalPeopleData" @handleChangeDetail="handleChangeDetail"/>
                <StreeModalContentDetail v-if="scoreDetail&&isDetail" :scoreDetail="scoreDetail"   @handleChangeDetail="handleChangeDetail"/>
            </template>
            <template v-else>
                <div class="score-empty">
                    <a-empty  style="width:100%;"/>
                </div>
            </template>
        </template>
        <!-- 跆拳道、空手道 -->
        <template v-else-if="currentMatch.programId==1||currentMatch.programId==2">
            <!-- 头部名称 -->
            <TaekwondoModalName v-if="gameModalPeopleData.technicalHeaderVo" :technicalHeaderVo="gameModalPeopleData.technicalHeaderVo"   />
            <TaekwondoModalAvatar v-if="gameModalPeopleData.technicalHeaderVo&&gameModalPeopleData.technicalHeaderVo.bluePlayers.length==1" :technicalHeaderVo="gameModalPeopleData.technicalHeaderVo" :combatName="this.currentMatch.combatName" />
            <TaekwondoModalAvatarGroup v-if="gameModalPeopleData.technicalHeaderVo&&gameModalPeopleData.technicalHeaderVo.bluePlayers.length>1"  :technicalHeaderVo="gameModalPeopleData.technicalHeaderVo" :combatName="this.currentMatch.combatName"/>
            <!-- 跆拳道数据为空判断 -->
            <template v-if="gameModalPeopleData.technicalHeaderVo&&gameModalPeopleData.technicalDetails.length>0">
               <TaekwondoModalContent v-if="gameModalPeopleData.technicalDetails&&gameModalPeopleData.technicalHeaderVo" :technicalDetails="gameModalPeopleData.technicalDetails" 
               :actionTrack="gameModalPeopleData.technicalHeaderVo.actionTrack"/>
            </template>
            <template v-else>
                <div class="score-empty">
                    <a-empty  style="width:100%;"/>
                </div>
            </template>
        </template>
        <!-- 艺术体操 -->
       <template v-else-if="currentMatch.programId==20">
            <!-- 头部名称 -->
            <TaekwondoModalName v-if="gameModalPeopleData.technicalHeaderVo" :technicalHeaderVo="gameModalPeopleData.technicalHeaderVo"   />
            <TaekwondoModalAvatar v-if="gameModalPeopleData.technicalHeaderVo&&gameModalPeopleData.technicalHeaderVo.bluePlayers.length==1" :technicalHeaderVo="gameModalPeopleData.technicalHeaderVo" :combatName="this.currentMatch.combatName" />
            <TaekwondoModalAvatarGroup v-if="gameModalPeopleData.technicalHeaderVo&&gameModalPeopleData.technicalHeaderVo.bluePlayers.length>1"  :technicalHeaderVo="gameModalPeopleData.technicalHeaderVo" :combatName="this.currentMatch.combatName"/>
            <template v-if="gameModalPeopleData.details" >
                <GymsModalContent v-if="gameModalPeopleData.details&&!isDetail" :scoreDetail="gameModalPeopleData.details" :allData="gameModalPeopleData" @handleChangeDetail="handleChangeDetail" />
                <GymsModalContentDetail v-if="gameModalPeopleData.details&&isDetail" :scoreDetail="scoreDetail" :details="gameModalPeopleData.details"    @handleChangeDetail="handleChangeDetail" />
            </template>
            <template v-else>
                <div class="score-empty">
                    <a-empty  style="width:100%;"/>
                </div>
            </template>
        </template>
        <!-- 兵道 -->
        <template v-else-if="currentMatch.programId==12">
            <!-- 头部名称 -->
            <MilitaryModalName v-if="gameModalPeopleData.technicalHeaderVo" :technicalHeaderVo="gameModalPeopleData.technicalHeaderVo"   />
            <MilitaryModalAvatar v-if="gameModalPeopleData.technicalHeaderVo&&gameModalPeopleData.technicalHeaderVo.bluePlayers.length==1" :technicalHeaderVo="gameModalPeopleData.technicalHeaderVo" :combatName="this.currentMatch.combatName" />
            <MilitaryModalAvatarGroup v-if="gameModalPeopleData.technicalHeaderVo&&gameModalPeopleData.technicalHeaderVo.bluePlayers.length>1"  :technicalHeaderVo="gameModalPeopleData.technicalHeaderVo" :combatName="this.currentMatch.combatName"/>
            <!-- 兵道数据为空判断 -->
            <template v-if="gameModalPeopleData.technicalDetails&&gameModalPeopleData.technicalDetails.length!=0">
               <MilitaryModalContent v-if="gameModalPeopleData.technicalDetails" :technicalDetails="gameModalPeopleData.technicalDetails" 
               :actionTrack="gameModalPeopleData.technicalHeaderVo.actionTrack"/>
            </template>
            <template v-else>
                <div class="score-empty">
                    <a-empty  style="width:100%;"/>
                </div>
            </template>
        </template>   
    </div>
</template>

<script>
//街舞
import StreeModalName from './stree/StreeModalName.vue'
import StreetModalAvatar from './stree/StreetModalAvatar.vue'
import StreetModalAvatarGroup from './stree/StreetModalAvatarGroup.vue'
import StreeModalContent from './stree/StreeModalContent.vue'
import StreeModalContentDetail from './stree/StreeModalContentDetail.vue'
//跆拳道
import TaekwondoModalName from './taekwondo/TaekwondoModalName.vue'
import TaekwondoModalAvatar from './taekwondo/TaekwondoModalAvatar.vue'
import TaekwondoModalAvatarGroup from './taekwondo/TaekwondoModalAvatarGroup.vue'
import TaekwondoModalContent from './taekwondo/TaekwondoModalContent.vue'
//兵道
import MilitaryModalName from './military/MilitaryModalName.vue'
import MilitaryModalAvatar from './military/MilitaryModalAvatar.vue'
import MilitaryModalAvatarGroup from './military/MilitaryModalAvatarGroup.vue'
import MilitaryModalContent from './military/MilitaryModalContent.vue'
//艺术体操
import GymsModalContent from './gyms/GymsModalContent.vue'
import GymsModalContentDetail from './gyms/GymsModalContentDetail.vue'
export default {
  name:'DefaultGameModal',
  props:{
    currentMatch:{
      type:Object,
    }
  },
  components: {
    StreeModalName,
    StreetModalAvatar,
    StreetModalAvatarGroup,
    StreeModalContent,
    StreeModalContentDetail,
    TaekwondoModalName,
    TaekwondoModalAvatar,
    TaekwondoModalAvatarGroup,
    TaekwondoModalContent,
    GymsModalContent,
    GymsModalContentDetail,
    MilitaryModalName,
    MilitaryModalAvatar,
    MilitaryModalAvatarGroup,
    MilitaryModalContent
  },
  data () {
    return {
      gameModalPeopleData:{},//人员数据
      gameModalScoreData:{},//对战分数数据
      isDetail:false,//是否为详情
      scoreDetail:{},
    }
  },
  methods: {
    //获取对战人和场次
    getGamePeopleData (){
      let data={matchId:this.currentMatch.matchId,matchField:this.currentMatch.matchField}
      this.$api.match.macthGamePeople(data).then((res)=>{
        if(res.status==0){
          this.gameModalPeopleData=res.data
        //   console.log('getGamePeopleData',this.gameModalPeopleData)
        }else{
          this.$message.info('请求错误')
        }
      })
    },
    //街舞&&街舞
    handleChangeDetail (scoreDetailData){
      this.scoreDetail=scoreDetailData
      this.isDetail=scoreDetailData.isDetail
    },
  },
  watch: {
  },
  computed: {

  },
  mounted () {
    this.getGamePeopleData()
  },
  updated () {

  },
}
</script>

<style lang="scss" scoped>
.game-modal-content{
  width: 1100px;
  margin: 0 auto;
  max-height: 700px;
  box-sizing: border-box;
  padding: 20px 0;
  //分数空样式
  .score-empty{
    width: 100%;
    height: 420px;
    text-align: center;
    line-height: 420px;
    display: flex;
    align-items: center;
    flex: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/comm/components/modal/DefaultGameModal.vue